import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/',
    component: () => import('@/pages/Landing.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },
  {
    //path: '/products/:id',
    path: '/products',
    component: () => import('@/pages/Products.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },
  {
    //path: '/products/:id',
    path: '/products/add',
    component: () => import('@/pages/ProductForm.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },
  {
    //path: '/products/:id',
    name: "product-edit",
    path: '/products/edit/:id',
    component: () => import('@/pages/ProductForm.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
    props: true   //ca sa recunoasca/3
  },
  {
    //path: '/products/:id',
    //name: "produc-details",
    path: '/products/:id',
    component: () => import('@/pages/Product.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
    props: true   //ca sa recunoasca/3
  },
  // categories
  {
    //path: '/categories/:id',
    path: '/categories',
    component: () => import('@/pages/Categories.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },
  {
    //path: '/categories/:id',
    path: '/categories/add',
    component: () => import('@/pages/CategoryForm.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },
  {
    //path: '/categories/:id',
    name: "category-edit",
    path: '/categories/edit/:id',
    component: () => import('@/pages/CategoryForm.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
    props: true   //ca sa recunoasca/3
  },
  {
    //path: '/categories/:id',
    //name: "produc-details",
    path: '/categories/:id',
    component: () => import('@/pages/Category.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
    props: true   //ca sa recunoasca/3
  },

  // consumptions
  {
    path: '/consumptions',
    component: () => import('@/pages/Consumptions.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },
  {
    path: '/consumptions/:id',
    component: () => import('@/pages/ConsumptionPage.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
    props: true   //ca sa recunoasca/3
  },
  {
    //path: '/categories/:id',
    path: '/consumptions/add',
    component: () => import('@/pages/ConsumptionForm.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },
  {
    //path: '/categories/:id',
    name: "consumptions-edit",
    path: '/consumptions/edit/:id',
    component: () => import('@/pages/ConsumptionForm.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
    props: true   //ca sa recunoasca/3
  },
  {
    path: '/consumptions/map',
    component: () => import('@/pages/ConsumptionMapPage.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },


  // login
  {
    path: '/login',
    component: () => import('@/pages/Login.vue'),
  },
  {
    path: '/users/me',
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },
  {
    path: '/stats/daily',
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },

  {
    path: '/admin/users',
    component: () => import('@/pages/users/List.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },

  {
    path: '/admin/users/view',
    component: () => import('@/pages/users/View.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },

  {
    path: '/admin/users/edit',
    component: () => import('@/pages/users/Edit.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
  },

  {
    path: '/admin/users/add',
    component: () => import('@/pages/users/Edit.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
    // trebuie setat authStore.selected_user = null ca sa mearga
  },

  {
    path: '/account/change-password',
    component: () => import('@/pages/account/ChangePassword.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
    // trebuie setat authStore.selected_user = null ca sa mearga
  },

  {
    path: '/account/change-username',
    component: () => import('@/pages/account/ChangeUsername.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
    // trebuie setat authStore.selected_user = null ca sa mearga
  },

  {
    path: '/account',
    component: () => import('@/pages/account/View.vue'),
    meta: { requiresAuth: true }, // ✅ ruta protejată
    // trebuie setat authStore.selected_user = null ca sa mearga
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const auth = useAuthStore()

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  next()
})


export default router
